const PRIMARY_COLORS = ['--rs-color-primary-light-theme', '--rs-color-primary-dim-light-theme', '--rs-color-primary-fog-light-theme', '--rs-color-primary-t-dim-light-theme', '--rs-color-primary-t-fog-light-theme', '--rs-color-primary-dark-theme', '--rs-color-primary-dim-dark-theme', '--rs-color-primary-fog-dark-theme', '--rs-color-primary-t-dim-dark-theme', '--rs-color-primary-t-fog-dark-theme'];

const extractPrimaryColors = styles => {
  const colors = {};
  PRIMARY_COLORS.forEach(varName => {
    colors[varName] = styles.getPropertyValue(varName) || 'initial';
  });
  return colors;
};
/** Check out `@rescui/colors/src/public-api.p.css` file */


const extractThemeFromCss = styles => {
  const themeDark = parseInt(styles.getPropertyValue('--rs-theme-dark'), 10) || 0;
  const themeFlip = parseInt(styles.getPropertyValue('--rs-theme-flip'), 10) || 0;
  const themeDarkCoefficient = themeDark * (1 - themeFlip) + themeFlip * (1 - themeDark);
  return themeDarkCoefficient === 1 ? 'dark' : 'light';
};

export { extractPrimaryColors, extractThemeFromCss };
